<template>
  <Card :container-class="opportunityStatusClass.classes" class="mb-5">
    <div class="p-4">
      <div class="d-flex align-items-center justify-content-between">
        <h6> {{ opportunity.name }} </h6>
        <AvatarBadge
            :fullname="opportunity?.contact?.fullname"
            :avatar-url="opportunity?.contact?.image"
            @onClick="redirectToContact(opportunity?.contact_id)"
        />
      </div>
      <div class="d-flex align-items-center justify-content-between my-2">
        <div>
          <span> {{ opportunity?.contact?.fullname }} </span> <span v-html="opportunity.feeling"></span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-2">
        <span class="small">
          {{ opportunity?.closing_date }}
        </span>
        <span>
          <i v-if="opportunityStatusClass.icon" :class="opportunityStatusClass.icon" class="me-2"></i>
          {{ $formatLocalAmount(opportunity?.expected_income) }} {{ currency }}
        </span>
      </div>
      <StepBar :current-step="opportunity?.opportunity_state?.order" :steps-number="6" />
    </div>
  </Card>
</template>

<script setup>

import Card from "./Card.vue";
import StepBar from "./StepBar.vue";
import {$formatLocalAmount} from "@/mixins/Helpers";
import AvatarBadge from "@/components/AvatarBadge.vue";
import {useRouter} from "vue-router";
import {computed} from "vue";
import {useStore} from "vuex";
import opportunityWonLostStatus from "@/Modules/CRM/composables/opportunityWonLostStatus";

const store = useStore()
const router = useRouter()

const props = defineProps({
  opportunity: {
    type: Object,
    default: () => ({
      name: ''
    })
  },
  currency: { type: String, default: '' }
})

const redirectToContact = (id) => {
  if(id) {
    router.push({ name: 'contact-view-path', params: {id} })
  }
}

const opportunityStatusClass = computed(() => {
  let classes = 'card mb-4'
  let icon = ''
  icon = ''
  if(props.opportunity.status === opportunityWonLostStatus.WON) {
    classes += 'border-start border-5 border-primary'
    icon = 'emojione-monotone--money-with-wings fs-6 text-primary'
  }
  if(props.opportunity.status === opportunityWonLostStatus.LOST) {
    classes += 'border-start border-5 border-danger'
    icon = 'fa fa-heart-broken text-danger'
  }
  return {classes, icon}
})

</script>

<style scoped>

</style>
